import ProductPricesFormList from "./Forms/ProductPricesFormList";
import useProductFormData from "../hooks/useProductFormData";
import ProductFormFields from "./Forms/ProductFormFields";
import { FaMoneyBillWave, FaSave } from "react-icons/fa";
import useProductModal from "../hooks/useProductModal";
import { Card, Col, Form, Modal, Row } from "antd";
import TooltipButton from "views/Documents/components/TooltipButton";
import { MdEdit } from "react-icons/md";
import { useTranslation } from "react-i18next";
import CardTitle from "components/CardTitle";

interface UpdateProductProps {
  id: ID;
  refetchProducts?: () => void;
}

export default function UpdateProduct({
  id,
  refetchProducts,
}: UpdateProductProps): React.ReactElement {
  const { t } = useTranslation();

  const { form, isOpen, showModal, handleOk, handleCancel, onFinish } = useProductModal({
    productId: id,
  });

  const {
    categoryOptions,
    operationsCategories,
    hasDeclareTva,
    counterpartByCategory,
    refetchGetProduct,
    onValuesChange,
  } = useProductFormData({ form, isOpen, productId: id });

  return (
    <>
      <TooltipButton placement="top" handleOnClick={showModal} icon={<MdEdit />} />
      <Modal
        title={t("Update product")}
        open={isOpen}
        onOk={handleOk}
        okText={t("Save")}
        okButtonProps={{
          icon: (
            <span className="anticon">
              <FaSave />
            </span>
          ),
        }}
        onCancel={handleCancel}
        width={"50%"}
        className="antd-modal"
      >
        <Form
          name="UpdateProduct"
          layout="vertical"
          form={form}
          onFinish={onFinish}
          onValuesChange={onValuesChange}
          autoComplete="off"
        >
          <Row gutter={[16, 16]}>
            <ProductFormFields
              categoryOptions={categoryOptions}
              operationsCategories={operationsCategories}
              hasDeclareTva={hasDeclareTva}
              counterpartByCategory={counterpartByCategory}
              showProductId={true}
            />
            <Col span={24}>
              <Card
                size="small"
                title={<CardTitle icon={<FaMoneyBillWave />} title={t("Prices by currency")} />}
                className="antd-newrai-card"
                headStyle={{ borderBottom: "1px solid #f0f0f0" }}
              >
                <ProductPricesFormList
                  refetchProduct={refetchGetProduct}
                  refetchProducts={refetchProducts}
                  isOpen={isOpen}
                />
              </Card>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}
